// extracted by mini-css-extract-plugin
export default {"root":"UnauthedHeader_root__NDk4R"};